<template>
  <div>
    <div class="">
      <UploadEvidence v-if="isSaving" :evidences="evidences" :protest-request="protestRequest" :admin="admin"></UploadEvidence>

      <div class="space-y-7 tracking-wide">

        <!-- ################################################################################ -->
        <!-- ## Add Closing Disclosure/Settlement Statement/Appraisal ## -->
        <!-- ################################################################################ -->

        <div v-if="closingStatementsOrApprisals().length == 0">
          <a href="javascript:void(0);" @click="addClosingStatementOrApprisal()" class="bg-blue-100 text-sm sm:text-base text-blue-700 font-medium px-5 py-3.5 border border-dashed border-blue-600 shadow-sm hover:shadow-md rounded block">
            <i class="fa fa-plus mr-0.5"></i> Add Closing Disclosure/Settlement Statement/Appraisal
          </a>
        </div>
        <div v-else>
          <label class="block text-gray-800 font-medium mb-1">Add Closing Disclosure/Settlement Statement/Appraisal</label>
          <show-evidence v-for="evidence in closingStatementsOrApprisals()" v-bind:key="evidence.uid" :evidence="evidence" v-on:update-evidences="updateEvidences" v-on:delete-evidence="deleteEvidence">
          </show-evidence>
        </div>

        <div class="border-b-2"></div>

        <!-- ################################################################################ -->
        <!-- ## Add Repair/Cosmatic/Other Issue ## -->
        <!-- ################################################################################ -->
        <div v-if="issues().length == 0">
          <a href="javascript:void(0);" @click="addIssue()" class="bg-blue-100 text-sm sm:text-base text-blue-700 font-medium px-5 py-3.5 border border-dashed border-blue-600 shadow-sm hover:shadow-md rounded block">
            <i class="fa fa-plus mr-0.5"></i> Add Repair/Cosmetic/Other Issue
          </a>
        </div>
        <div v-else>
          <label class="block text-gray-800 font-medium mb-1">Add Repair/Cosmetic/Other Issue</label>
          <small class="text-gray-700">
            If you submitted a settlement statement or appraisal above, any additional cosmetic or repair issues must have occurred after the appraisal date or after your purchase date in order for the appraisal district to consider it valid evidence
          </small>
          <show-evidence v-for="evidence in issues()" v-bind:key="evidence.uid" :evidence="evidence" v-on:update-evidences="updateEvidences" v-on:delete-evidence="deleteEvidence">
          </show-evidence>
        </div>
        <div class="text-left" v-if="issues().length > 0">
          <a href="javascript:void(0);" @click="addIssue()" class="text-sm font-medium text-blue-700 underline -mt-2">
            <i class="fa fa-plus"></i> Add Repair/Cosmetic/Other Issue
          </a>
        </div>
      </div>

    </div>

    <div class="text-center mt-6 sm:mt-8 flex justify-center">
      <a href="javascript:void(0);" @click="cancel()" class="inline-block w-full sm:w-auto px-2 sm:px-6 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 mr-6">
        Cancel
      </a>
      <button @click="submitHandler()" :disabled="evidences.length==0" class="inline-block w-full sm:w-auto px-2 sm:px-6 py-2 border border-transparent shadow-sm text-base font-medium rounded-md text-white focus:outline-none" :class="evidences.length==0 ? 'bg-gray-400 cursor-not-allowed' : 'bg-indigo-500 hover:bg-indigo-600 focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'">
        Upload
      </button>
    </div>

  </div>
</template>

<script>
import ShowEvidence from "../Evidences/Show.vue";
import UploadEvidence from "../Evidences/Modal/UploadEvidence.vue";
import { helpers } from "../../../../mixins/helpers.js";
import { siteUrl } from "../../../../config/base.js";

export default {
  props: ["evidenceTypes", "protestRequest","admin"],

  mixins: [helpers],

  components: {
    ShowEvidence,
    UploadEvidence,
  },

  data() {
    return {
      evidences: [],
      message: "Please wait while uploading.",
      isSaving: false,
      hasClosingStatementOrApprisalBox: false,
      totalImagesUploaded: 0,
      convertingImageToFile:false,
    };
  },
  created() {
    this.initializeSavedEvidence();
  },

  methods: {
    initializeSavedEvidence() {
      let protestRequestEvidences = this.protestRequest.evidences;
      if (protestRequestEvidences.length == 0) {
        return;
      }
      _.map(protestRequestEvidences, (evidence) => {
        if ([3, 4].includes(evidence.evidence_type_id)) {
          this.addClosingStatementOrApprisal(evidence);
        }
        if ([1, 2, 5].includes(evidence.evidence_type_id)) {
          this.addIssue(evidence);
        }
      });
    },

    closingStatementsOrApprisals() {
      return _.filter(this.evidences, (x) => x.issue == null);
    },

    addClosingStatementOrApprisal(evidence = {}) {
      this.hasClosingStatementOrApprisalBox = true;

      let initialValues = {
        protest_request_uid: this.protestRequest.uid,
        uid: this.guid(),
        types: _.filter(this.evidenceTypes, (x) => [3, 4].includes(x.id)),
        hasClosingStatementOrApprisalBox: this.hasClosingStatementOrApprisalBox,
      };

      this.evidences.push({ ...initialValues, ...evidence });
    },

    addIssue(evidence = {}) {
      let initialValues = {
        protest_request_uid: this.protestRequest.uid,
        uid: this.guid(),
        types: _.filter(this.evidenceTypes, (x) => ![3, 4].includes(x.id)),
        issue: true,
      };

      this.evidences.push({ ...initialValues, ...evidence });
    },

    issues() {
      return _.filter(this.evidences, (x) => x.issue);
    },

    cancel() {
      window.location.href = this.admin
      ? siteUrl + "/admin/protest-requests/" + this.protestRequest.uid + "/evidences/show"
      : "/user-properties";
    },

    deleteEvidence(data) {
      _.remove(this.evidences, function (evidence) {
        return evidence.uid == data.uid;
      });
      this.$forceUpdate();
    },

    updateEvidences(data) {
      let index = this.evidences.findIndex(
        (evidence) => evidence.uid === data.uid
      );
      this.evidences.splice(index, 1, data);

      var totalImagesUploaded = 0;

      _.each(this.evidences, (evidence) => {
        if(evidence.uploads){
          var image_uploads = evidence.uploads.filter(
            (upload) => !upload.is_invoice && (upload.img_src && upload.img_src !="")
          );
          // console.log("image_uploads:", image_uploads);
          totalImagesUploaded += image_uploads.length;
        }


      });

      this.totalImagesUploaded = totalImagesUploaded;
    },

    submitHandler() {
      // check for img_src is null and change the img_src to file
      this.createImageFile();
      if(this.convertingImageToFile){
        if (!this.validate()) {
          _.each(this.evidences, (evidence) => {
              evidence.errors.push("Please check evidence");
          });

          return false;
        }
      }
      this.isSaving = true;
    },

    validate() {
      var hasValidationPassed = true;

      if (this.totalImagesUploaded > 40) {
        alert(
          "Maximum images allowed to upload in Repair/Cosmetic/Other Issues are 40"
        );
        hasValidationPassed = false;
      }

      _.each(this.evidences, (evidence) => {
        evidence.errors = [];
        if (!evidence.evidence_type_id) {
          evidence.errors.push("Please select the evidence type.");
          hasValidationPassed = false;
        }

        if ([1, 2].includes(evidence.evidence_type_id)) {
          if (this.validateEvidenceType1_2(evidence)) {
            hasValidationPassed = false;
          }
        }

        if (evidence.evidence_type_id == 3) {
          if (this.validateEvidenceType3(evidence)) {
            hasValidationPassed = false;
          }
        }

        if (evidence.evidence_type_id == 4) {
          if (this.validateEvidenceType4(evidence)) {
            hasValidationPassed = false;
          }
        }

        if (evidence.evidence_type_id == 5) {
          if (this.validateEvidenceType5(evidence)) {
            hasValidationPassed = false;
          }
        }
      });

      return hasValidationPassed;
    },

    validateEvidenceType3(evidence) {
      let error = false;

      // Purchase Price
      if (!evidence.purchase_price) {
        evidence.errors.push("Please provide the purchase price.");
        error = true;
      }

      // Statement Date
      if (!evidence.appraisal_date) {
        evidence.errors.push("Please provide the statement date.");
        error = true;
      }

      // Uploads
      if (evidence.uploads && evidence.uploads.length == 0) {
        evidence.errors.push("Please upload file.");
        error = true;
      } else {
        _.each(evidence.uploads, (file) => {
          if (!file.id && !file.type.match(".pdf")) {
            evidence.errors.push("Please upload pdf only.");
            error = true;
          }
        });
      }

      return error;
    },

    validateEvidenceType1_2(evidence) {
      let error = false;
      // Description
      if (!evidence.description) {
        evidence.errors.push("Please provide the issue description.");
        error = true;
      }

      // Cost Of Repairs
      if (!evidence.cost_of_repairs) {
        evidence.errors.push("Please provide the cost of repair.");
        error = true;
      }

      // Uploads
      if (!evidence.invoice && evidence.uploads.length == 0) {
        evidence.errors.push("Please upload atleast one photo or file.");
        error = true;
      } else if (evidence.uploads && evidence.uploads.length > 0) {
        _.each(evidence.uploads, (file) => {
          if (!file.id && !file.type.match("image/*")) {
            evidence.errors.push("Please upload image only.");
            error = true;
          }
        });
      }

      return error;
    },

    validateEvidenceType4(evidence) {
      let error = false;

      // Appraial Date
      if (!evidence.appraisal_date) {
        evidence.errors.push("Please provide the appraisal date.");
        error = true;
      }

      // Appraisal Value
      if (!evidence.appraised_value) {
        evidence.errors.push("Please provide the appraisal value.");
        error = true;
      }

      // Uploads
      if (evidence.uploads && evidence.uploads.length == 0) {
        evidence.errors.push("Please upload file.");
        error = true;
      } else if (evidence.uploads && evidence.uploads.length > 0) {
        _.each(evidence.uploads, (file) => {
          if (!file.id && !file.type.match(".pdf")) {
            evidence.errors.push("Please upload pdf only.");
            error = true;
          }
        });
      }

      return error;
    },

    validateEvidenceType5(evidence) {
      let error = false;
      // Description
      if (!evidence.description) {
        evidence.errors.push("Please provide the other description.");
        error = true;
      }

      // Cost Or  Value Impact
      if (!evidence.cost_or_value_impact) {
        evidence.errors.push("Please provide the cost/value impact.");
        error = true;
      }

      // Uploads
      if (!evidence.invoice && evidence.uploads.length == 0) {
        evidence.errors.push("Please upload atleast one photo or file.");
        error = true;
      } else if (evidence.uploads && evidence.uploads.length > 0) {
        _.each(evidence.uploads, (file) => {
          if (!file.id && !file.type.match("image/*")) {
            evidence.errors.push("Please upload image only.");
            error = true;
          }
        });
      }

      return error;
    },

    createImageFile(){
      for (let index = 0; index < this.evidences.length; index++) {
        if([1,2,5].includes(this.evidences[index].evidence_type_id)){
          let uploadedImagesFile = [];
            for (let i = 0; i < this.evidences[index].uploads.length; i++) {
              if(this.evidences[index].uploads[i].file_path){
                uploadedImagesFile.push(this.evidences[index].uploads[i]);
              }
              if(!this.evidences[index].uploads[i].file_path && this.evidences[index].uploads[i].img_src !== '' ){
                var image_file =  this.dataURLtoFile(this.evidences[index].uploads[i].img_src,this.evidences[index].uploads[i].file_name)
                image_file.img_src = this.evidences[index].uploads[i].img_src;
                image_file.file_name = this.evidences[index].uploads[i].file_name;
                uploadedImagesFile.push(image_file);
              }
            }
            this.evidences[index].uploads = uploadedImagesFile;
        }
      }
      this.convertingImageToFile = true;
    },

  dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);

      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, {type:mime});
  },
  },


};
</script>